/* OriginalSongCard1.js */

import React from 'react';
import { Col, Row } from 'reactstrap';
import { IoTrashBinOutline } from 'react-icons/io5';
import Strings from '../../translations/Translations';

export default function OriginalSongCard1({ originalSong, removeOriginalSong }) {
  return (
    <div className='alert alert-success shadow-lg'>
      <Row>
        <Col md={10}>
          <p className='mb-0'><small className='text-muted'>{Strings('original_song_uploaded')}</small></p>
          <p className='mb-1 h3'>{originalSong && originalSong.osso && originalSong.osso}</p>
          <p className='mb-2 h5'>{originalSong && originalSong.osba && originalSong.osba}</p> 
          <p className='mb-0'>{Strings('genre')}: {originalSong && originalSong.genre && originalSong.genre}</p>
        </Col>
        <Col md={2} className='d-flex justify-content-end align-items-start'>
          <IoTrashBinOutline size={20} className='cursor-pointer' onClick={() => { if (removeOriginalSong) { removeOriginalSong(); } }} />
        </Col>
      </Row>
    </div>
  );
}
